"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = require("events");

var BaseTransport = function (_EventEmitter) {
  _inherits(BaseTransport, _EventEmitter);

  function BaseTransport() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, BaseTransport);

    var _this = _possibleConstructorReturn(this, (BaseTransport.__proto__ || Object.getPrototypeOf(BaseTransport)).call(this));

    _this.options = options;
    _this.node = node;
    _this.peers = [];
    return _this;
  }

  _createClass(BaseTransport, [{
    key: "send",
    value: function send(message, peer) {
      return new Promise(function (resolve) {
        peer.output.write(message, resolve);
      });
    }
  }, {
    key: "_initIncomingPeer",
    value: function _initIncomingPeer(peer) {
      var _this2 = this;

      this._initPeer(peer);
      peer.input.on("end", function () {
        return _this2.emit("client-disconnected", peer);
      });
      this.emit("client-connected", peer);
    }
  }, {
    key: "_initOutgoingPeer",
    value: function _initOutgoingPeer(peer) {
      var _this3 = this;

      this._initPeer(peer);
      peer.input.on("end", function () {
        return _this3.emit("disconnected", peer);
      });
      this.emit("connected", peer);
    }
  }, {
    key: "_initPeer",
    value: function _initPeer(peer) {
      var _this4 = this;

      this.peers.push(peer);

      peer.input.on("end", function () {
        _this4._teardownPeer(peer);
      });
      peer.input.on("data", function (message) {
        _this4.emit("message", { message: message, peer: peer });
      });
      peer.input.on("error", function (err) {
        console.log("SOCKET ERROR", err);
      });
      peer.output.on("error", function (err) {
        console.log("SOCKET ERROR", err);
      });
    }
  }, {
    key: "_teardownPeer",
    value: function _teardownPeer(peer) {
      this.peers.splice(this.peers.indexOf(peer), 1);
    }
  }]);

  return BaseTransport;
}(EventEmitter);

module.exports = BaseTransport;


//////////////////
// WEBPACK FOOTER
// ../lib/transport/base.js
// module id = 562
// module chunks = 0